import resolveConfig from 'tailwindcss/resolveConfig';
import * as tailwindConfig from './../../../tailwind.config';

import { useEffect, useState } from 'react';

// we call the resolveConfig out here, just ONCE, when this file is first imported
const fullConfig = resolveConfig(tailwindConfig);
const breakpointMap = fullConfig.theme.screens;

export const useMedia = (screenSize) => {
    const selectedScreenWidth = breakpointMap[screenSize];

    if (!selectedScreenWidth) {
        console.warn(
            `The specified size ${screenSize} is not available in the current configuration. Unexpected behavior may occur`,
        );
    }

    const query = `(min-width: ${selectedScreenWidth})`;
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    // cDM, cDU
    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = (event) => {
            setMatches(event.matches);
        };
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, [query, matches]);

    return matches;
};
